import { Component, OnInit, ViewChild } from '@angular/core';
import { AllLiquidationsTabComponent } from '../../shared/widgets/sellers/all-liquidations-tab/all-liquidations-tab.component';
import { LiquidateReferrersTabTabComponent } from '../../shared/widgets/sellers/liquidate-referrers-tab/liquidate-referrers-tab.component';
import { SummaryItem } from '../../shared/components/module-summary-bar/module-summary-bar.component';
import { SellerService } from '../../services/sellers/sellers.service';

export enum LiquidationsViewMode {
  HISTORY = 'history',
  TEAM = 'team',
  REFERRALS = 'referrals'
}

@Component({
    selector: 'app-liquidations',
    templateUrl: './liquidations.component.html',
    styleUrls: ['./liquidations.component.scss'],
    standalone: false
})
export class LiquidationsComponent implements OnInit {

  @ViewChild(AllLiquidationsTabComponent) historyTab?: AllLiquidationsTabComponent;
  @ViewChild(LiquidateReferrersTabTabComponent) referralsTab?: LiquidateReferrersTabTabComponent;

  LiquidationsViewMode = LiquidationsViewMode;
  viewMode: LiquidationsViewMode = LiquidationsViewMode.TEAM;
  searchTerm: string = '';
  
  summaryItems: SummaryItem[] = [];

  constructor(private sellerService: SellerService) {}

  ngOnInit(): void {
    this.loadSummary();
  }

  loadSummary() {
    this.sellerService.getCommissionsSummary().subscribe({
      next: (res: any) => {
        if (res.ok && res.data) {
          const { total_pending, total_paid, active_sellers, total_clients, pending_referrals } = res.data;
          
          const safePending = parseFloat(total_pending) || 0;
          const safePaid = parseFloat(total_paid) || 0;

          this.summaryItems = [
            {
              title: 'Pending Commissions',
              value: '$ ' + safePending.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              description: 'Total pending commission amount',
              color: '#F59E0B'
            },
            {
              title: 'Total Paid (YTD)',
              value: '$ ' + safePaid.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              description: 'Total paid out this year',
              color: '#22C55E'
            },
            {
              title: 'Active Sales Reps',
              value: active_sellers || 0,
              color: '#1F7BF6'
            },
            {
              title: 'Total Sourced Clients',
              value: total_clients || 0,
              color: '#0D5EA8'
            },
            {
              title: 'Pending Referrals',
              value: pending_referrals || 0,
              color: '#9CA3AF'
            }
          ];
        }
      },
      error: () => {}
    });
  }

  toggleView(mode: LiquidationsViewMode) {
    this.viewMode = mode;
    this.searchTerm = '';
  }

  onSearch(term: string) {
    this.searchTerm = term;
  }

}
